export const articleDetails = {
  'zhiming-wanghong-zhibo-fanche': {
    id: 1,
    title: '知名网红直播间翻车，私下聊天记录遭曝光，人设彻底崩塌',
    excerpt: '曾经拥有千万粉丝的顶流网红，在近日一场直播中意外翻车，随后大量私下聊天记录被知情人曝光，内容令人瞠目结舌。',
    category: '网红黑料',
    categorySlug: 'wanghong',
    date: '2026-07-06',
    author: '吃瓜前线记者',
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20dramatic%20crash%20effect%2C%20dark%20atmosphere%2C%20warm%20amber%20lighting%2C%20mysterious%20social%20media%20scandal%2C%20cinematic%20editorial%20style&width=1200&height=600&seq=article-detail-01&orientation=landscape',
    content: [
      { type: 'heading', text: '直播翻车全过程' },
      { type: 'paragraph', text: '7月6日晚间，拥有超过1200万粉丝的知名网红"甜心小喵"在抖音直播间进行日常带货时，意外露出了一段私下聊天记录。当时她正在向粉丝展示一款美妆产品，手机屏幕投射到直播间画面中，竟意外弹出了与某品牌方的私密对话。' },
      { type: 'paragraph', text: '聊天记录显示，该网红在与品牌方沟通时态度极其傲慢，不仅对产品提出诸多不合理要求，还直言"反正粉丝都会买，质量差点无所谓"。这番言论一经曝光，瞬间引爆了整个直播间的弹幕。' },
      { type: 'heading', text: '更多黑料接连曝光' },
      { type: 'paragraph', text: '随着直播翻车事件的持续发酵，越来越多的知情人站了出来。一位自称是该网红前助理的人士向吃瓜黑料网爆料，提供了大量该网红私下辱骂工作人员、数据造假、以及与多名已婚男士保持暧昧关系的聊天截图。' },
      { type: 'paragraph', text: '这些聊天记录中，该网红多次使用侮辱性词汇形容自己的粉丝群体，称他们为"韭菜"和"提款机"。同时，她还被爆出与直播平台运营人员勾结，利用机器人刷量制造虚假人气。' },
      { type: 'heading', text: '品牌方火速解约' },
      { type: 'paragraph', text: '事件发生后，与其合作的多个品牌方迅速做出反应。截至发稿时，已有至少8个品牌宣布终止与该网红的合作关系，其中包括某知名国际美妆品牌和一家头部零食企业。' },
      { type: 'paragraph', text: '某品牌公关负责人在接受采访时表示："我们对合作伙伴的人品和职业操守有严格要求，签约前会进行全面的背景调查。但这次的事件表明，有些人在镜头前后的表现差异巨大，我们感到非常失望。"' },
      { type: 'heading', text: '网红本人紧急回应' },
      { type: 'paragraph', text: '面对铺天盖地的质疑声，该网红于7月7日凌晨发布了一段道歉视频。视频中她哭诉称聊天记录是被恶意剪辑的，部分内容属于断章取义，但并未就具体问题作出有力回应。' },
      { type: 'paragraph', text: '对此，广大网友并不买账。相关话题在微博热搜榜持续霸榜超过12小时，"甜心小喵翻车"话题累计阅读量突破5亿。大量粉丝表示脱粉，其社交账号在24小时内掉粉超过200万。' },
      { type: 'heading', text: '行业反思' },
      { type: 'paragraph', text: '此次事件再次引发了对网红行业规范化的讨论。业内专家指出，随着直播带货行业的快速发展，部分网红在巨大的利益面前逐渐迷失自我，忽视了基本的职业操守和对粉丝的尊重。' },
      { type: 'paragraph', text: '吃瓜黑料网将持续关注此事件的后续发展，为全网吃瓜群众带来最新最全的报道。' },
    ],
    tags: ['网红翻车', '直播带货', '人设崩塌', '聊天记录曝光'],
    relatedArticles: [
      {
        id: 102, title: '情侣网红分手互撕，双方各执一词爆出大量猛料', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-06',
        image: 'https://readdy.ai/api/search-image?query=Broken%20heart%20symbolism%20on%20dark%20background%2C%20dramatic%20lighting%2C%20couple%20fight%20scandal&width=600&height=400&seq=related-01&orientation=landscape',
        slug: 'qinglv-wanghong-fenshou-husi',
      },
      {
        id: 104, title: '美食博主被曝使用过期食材，粉丝怒斥欺骗消费者', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-04',
        image: 'https://readdy.ai/api/search-image?query=Dark%20kitchen%20spoiled%20food%2C%20dramatic%20lighting%2C%20food%20blogger%20scandal&width=600&height=400&seq=related-02&orientation=landscape',
        slug: 'meishi-bozhu-guoqi-shicai',
      },
      {
        id: 103, title: '选秀冠军被爆学历造假，昔日采访言论被扒', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-05',
        image: 'https://readdy.ai/api/search-image?query=Graduation%20cap%20on%20dark%20surface%2C%20dramatic%20lighting%2C%20academic%20fraud%20scandal&width=600&height=400&seq=related-03&orientation=landscape',
        slug: 'xuanxiu-guanjun-xueli-zaojia',
      },
    ],
    reviewer: {
      name: '匿名爆料人A',
      contact: '已核实信息源',
      avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20silhouette%20profile%20on%20dark%20background%2C%20mysterious%20whistleblower%20identity%2C%20minimalist%20icon%20style&width=100&height=100&seq=reviewer-avatar-01&orientation=squarish',
      rating: 4.8,
      comment: '作为一名在该网红团队工作过的人，我可以确认这些聊天记录100%真实。她私下里就是这样的人，终于有人曝光了。希望更多人看清她的真面目。',
    },
  },
  'dingliu-nanxing-shenye-mihui': {
    id: 2,
    title: '顶流男星深夜密会神秘女子，酒店同框照流出，粉丝集体破防',
    excerpt: '某顶流男星被拍到深夜与一名神秘女子共同进入高端酒店，两人举止亲密，照片一经曝光立即引发全网热议。',
    category: '明星塌房',
    categorySlug: 'mingxing',
    date: '2026-07-05',
    author: '吃瓜特派员',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%2C%20paparazzi%20style%20photography%2C%20dramatic%20golden%20lighting%2C%20celebrity%20scandal%2C%20dark%20mysterious%20atmosphere%2C%20cinematic&width=1200&height=600&seq=article-detail-02&orientation=landscape',
    content: [
      { type: 'heading', text: '深夜密会全过程' },
      { type: 'paragraph', text: '7月5日凌晨1点左右，某知名顶流男星被拍到独自驾车前往北京某高端酒店。约15分钟后，一名身着黑色连衣裙的神秘女子也抵达酒店，两人在酒店大堂短暂交流后共同进入了电梯。' },
      { type: 'paragraph', text: '据现场目击者描述，两人举止亲密，男星还贴心地为该女子提包。直到次日早上8点，两人才先后离开酒店，男星先行从地下车库驱车离开，女子随后从酒店正门打车离去。' },
      { type: 'heading', text: '粉丝反应激烈' },
      { type: 'paragraph', text: '照片一经曝光，该男星的粉丝群体瞬间炸开了锅。大量粉丝在社交平台上表示"心碎了"、"不敢相信"。部分极端粉丝甚至开始人肉搜索照片中的神秘女子，试图挖出其身份信息。' },
      { type: 'paragraph', text: '更有粉丝翻出该男星此前在采访中声称"目前单身，专注事业"的言论，指责其欺骗粉丝感情。相关话题在微博热搜榜一度冲上第一，阅读量迅速突破8亿。' },
      { type: 'heading', text: '工作室紧急公关' },
      { type: 'paragraph', text: '事件发酵后，该男星工作室于7月5日下午发布声明，称照片中的女子是男星的"多年好友"，两人只是正常社交，否认存在恋爱关系。但这一解释并未平息粉丝的怒火。' },
    ],
    tags: ['明星塌房', '顶流男星', '酒店密会', '粉丝破防'],
    relatedArticles: [
      {
        id: 202, title: '某女星与前经纪公司解约内幕曝光，违约金数额惊人', category: '明星塌房', categorySlug: 'mingxing', date: '2026-07-06',
        image: 'https://readdy.ai/api/search-image?query=Legal%20documents%20on%20dark%20desk%20dramatic%20lighting%2C%20contract%20dispute%20scandal&width=600&height=400&seq=related-04&orientation=landscape',
        slug: 'nvxing-jingji-gongsi-jiuyue',
      },
      {
        id: 203, title: '知名导演潜规则女演员录音曝光，圈内炸锅', category: '明星塌房', categorySlug: 'mingxing', date: '2026-07-05',
        image: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20dark%20soundstage%2C%20casting%20couch%20scandal%20theme&width=600&height=400&seq=related-05&orientation=landscape',
        slug: 'zhiming-daoyan-qian-guize',
      },
      {
        id: 205, title: '说唱歌手吸毒实锤视频疯传，代言品牌连夜解约', category: '明星塌房', categorySlug: 'mingxing', date: '2026-07-03',
        image: 'https://readdy.ai/api/search-image?query=Dark%20music%20studio%20red%20dramatic%20lighting%2C%20hip%20hop%20drug%20scandal&width=600&height=400&seq=related-06&orientation=landscape',
        slug: 'shuochang-geshou-xidu-shichui',
      },
    ],
    reviewer: {
      name: '圈内知情人B',
      contact: '已核实身份',
      avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20professional%20silhouette%20on%20dark%20background%2C%20mysterious%20insider%2C%20minimalist%20style&width=100&height=100&seq=reviewer-avatar-02&orientation=squarish',
      rating: 4.5,
      comment: '圈内人都知道这位男星根本不是单身人设，他交往的对象不止一个。这次被拍到只是冰山一角，后面还有更大的瓜。',
    },
  },
  'xuanxiu-guanjun-xueli-zaojia': {
    id: 3,
    title: '选秀冠军被爆学历造假，昔日采访言论被扒，人设彻底翻车',
    excerpt: '近日有网友深扒某选秀节目冠军的背景资料，发现其声称的名校学历存在严重造假嫌疑，多段早期采访视频中的言论也前后矛盾。',
    category: '网红黑料',
    categorySlug: 'wanghong',
    date: '2026-07-04',
    author: '吃瓜调查组',
    image: 'https://readdy.ai/api/search-image?query=Graduation%20cap%20and%20fake%20diploma%20on%20dark%20surface%2C%20dramatic%20lighting%2C%20academic%20scandal%2C%20cinematic%20investigative%20mood&width=1200&height=600&seq=article-detail-03&orientation=landscape',
    content: [
      { type: 'heading', text: '学历造假疑云' },
      { type: 'paragraph', text: '近日，有网友在社交媒体上发帖称，某知名选秀节目冠军选手声称自己毕业于某985名校的履历存在严重问题。该网友通过学信网查询发现，该选手在该校的学籍信息并不存在。' },
      { type: 'paragraph', text: '更令人震惊的是，该选手在多个场合声称自己"从名校退学追逐音乐梦想"的故事似乎纯属虚构。有校友表示从未在学校见过此人，教务系统也无法查到其任何记录。' },
      { type: 'heading', text: '早期言论前后矛盾' },
      { type: 'paragraph', text: '随着调查的深入，网友们开始挖掘该选手早期的采访视频。结果发现其在不同场合关于学历的说法前后矛盾：有时说是大二退学，有时又说是大三退学；有时声称是经管学院，有时又说是艺术学院。' },
      { type: 'paragraph', text: '这些矛盾的言论被整理成合集视频后，在网络上迅速传播，播放量在24小时内突破1000万。越来越多的网友开始质疑该选手从一开始就在打造虚假的"学霸"人设。' },
    ],
    tags: ['学历造假', '选秀冠军', '人设翻车', '名校骗局'],
    relatedArticles: [
      {
        id: 101, title: '知名网红直播间翻车，私下聊天记录遭曝光', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-06',
        image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20dramatic%20crash%2C%20dark%20atmosphere%2C%20scandal%20exposure&width=600&height=400&seq=related-07&orientation=landscape',
        slug: 'zhiming-wanghong-zhibo-fanche',
      },
      {
        id: 102, title: '情侣网红分手互撕，双方各执一词爆出大量猛料', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-06',
        image: 'https://readdy.ai/api/search-image?query=Broken%20heart%20dark%20background%2C%20dramatic%20lighting%2C%20couple%20scandal&width=600&height=400&seq=related-08&orientation=landscape',
        slug: 'qinglv-wanghong-fenshou-husi',
      },
      {
        id: 106, title: '美妆博主带货翻车，直播间怒骂品牌方被录屏', category: '网红黑料', categorySlug: 'wanghong', date: '2026-07-02',
        image: 'https://readdy.ai/api/search-image?query=Makeup%20products%20scattered%20dark%20surface%2C%20dramatic%20lighting%2C%20beauty%20scandal&width=600&height=400&seq=related-09&orientation=landscape',
        slug: 'meizhuang-bozhu-daihuo-fanche',
      },
    ],
    reviewer: {
      name: '校友知情人C',
      contact: '学信网已核实',
      avatar: 'https://readdy.ai/api/search-image?query=Student%20silhouette%20on%20dark%20background%2C%20mysterious%20campus%20insider%2C%20minimalist&width=100&height=100&seq=reviewer-avatar-03&orientation=squarish',
      rating: 4.9,
      comment: '我是这所学校的毕业生，在学校呆了四年从没见过这个人。学校官方也不承认有这个学生。他的整个故事都是编造的，就是为了营造励志人设。',
    },
  },
};

export function getArticleBySlug(slug: string) {
  return articleDetails[slug as keyof typeof articleDetails] || Object.values(articleDetails)[0] || null;
}
